import {
  buildClient,
  CommitmentPolicy,
  getClient,
  KMS,
  KmsKeyringBrowser,
  configureFallback
} from '@aws-crypto/client-browser';
import * as base64 from 'byte-base64';
import { subtle } from './msrcrypto';
import { jsonToArray } from './utils';
import { AlgorithmSuiteIdentifier } from '@aws-crypto/material-management';

configureFallback(subtle)
  .then()
  .catch(e => console.log(e));

const { encrypt } = buildClient(CommitmentPolicy.FORBID_ENCRYPT_ALLOW_DECRYPT);

const encryptData = async data => {
  const generatorKeyId = process.env.FORM_ENCRYPTOR_GENERATOR_KEY;

  const clientProvider = getClient(KMS, {
    credentials: {
      accessKeyId: process.env.ENCRYPTOR_ACCESS_KEY,
      secretAccessKey: process.env.ENCRYPTOR_SECRET_ACCESS_KEY
    }
  });

  const keyIds = [process.env.FORM_ENCRYPTOR_KEY_IDS];

  const keyring = new KmsKeyringBrowser({
    clientProvider,
    generatorKeyId,
    keyIds
  });

  const context = {
    stage: 'forms',
    purpose: 'encryption upload',
    origin: 'us-east-1'
  };

  try {
    const { result } = await encrypt(keyring, jsonToArray(data), {
      encryptionContext: context
    });
    return base64.bytesToBase64(result);
  } catch (e) {
    return fallback(keyring, jsonToArray(data), context);
  }
};

const fallback = async (keyring, data, context) => {
  try {
    const { result } = await encrypt(keyring, data, {
      encryptionContext: context,
      suiteId: AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16
    });
    return base64.bytesToBase64(result);
  } catch (e) {
    console.log(e);
  }
};

export default encryptData;
